// For numbers = integer, decimals or allow 0 at first value
export function CurrencyInputDirective(UtilService) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, element, attrs, ctrl) {
      // validatePattern(element, 'currency');

      let utils = new UtilService(scope);
      utils.validatePattern(element, 'currency');

      return ctrl.$parsers.push(function (inputValue) {
        var parts = (1234.5).toLocaleString().match(/(\D+)/g);

        var inputVal = element.val();
        inputVal = inputVal.split(parts[0]).join('');
        inputVal = inputVal.split(parts[1]).join('.');

        // Allow 0 on first input value
        if (attrs.currencyInput === '0') {
          // We enter another value after 0
          // clearing left side zeros
          if (inputVal.length > 1 && inputVal.charAt(0) === '0') {
            inputVal = inputVal.substr(1);
          }
        } else {
          // clearing left side zeros of decimals
          if (inputVal.charAt(0) === '0' || inputVal.charAt(0) === '.') {
            inputVal = inputVal.substr(1);
          }
        }

        var point = inputVal.indexOf('.');
        if (point >= 0) {
          inputVal = inputVal.slice(0, point + 3);
        }

        var decimalSplit = inputVal.split('.');
        var intPart = decimalSplit[0];

        var decPart = '';
        if (attrs.currencyInput !== 'no-decimals') {
          decPart = decimalSplit[1] === undefined ? '' : '.' + decimalSplit[1];
        }

        var res = intPart + decPart;

        if (res !== inputValue) {
          ctrl.$setViewValue(res);
          ctrl.$render();
        }

        // To work with validations
        return res;
      });
    }
  };
}

CurrencyInputDirective.$inject = ['UtilService'];
